var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColdBlowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.54688C3.89418 1.54688 3.89418 3.56368 7.78836 3.56368C11.6825 3.56368 11.6825 1.54688 15.5767 1.54688",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5605 2.89122L15.5764 1.54669L14.5605 0.202148",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2012 6.91137C11.9519 6.33658 12.7104 5.24414 15.5768 5.24414",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.24414C2.86476 5.24414 3.62328 6.33658 5.37566 6.91137",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5605 6.58849L15.5764 5.24395L14.5605 3.89941",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5761 8.94141C14.0556 8.94141 13.1278 9.25065 12.332 9.62376",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24402 9.62208C2.44825 9.25065 1.52042 8.94141 0 8.94141",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5605 10.2867L15.5764 8.94219L14.5605 7.59766",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14356 7.93359L7.78906 8.942",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43359 7.93359L7.78809 8.942",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78906 14.6557V7.26074",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43359 13.984L7.78809 12.9756",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14356 13.984L7.78906 12.9756",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82617 8.28125L6.0285 9.94974",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4707 10.6103L6.02753 9.9502",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0141 12.8069L4.5625 9.10938",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7492 13.6353L9.54688 11.9668",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1037 11.3066L9.54688 11.9667",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1037 10.6103L9.54688 9.9502",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7492 8.28125L9.54688 9.94974",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 12.8069L11.0141 9.10938",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4707 11.3066L6.02753 11.9667",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82617 13.6353L6.0285 11.9668",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78762 15.6647C10.4059 15.6647 12.5284 13.5578 12.5284 10.9588C12.5284 8.35982 10.4059 6.25293 7.78762 6.25293C5.16938 6.25293 3.04688 8.35982 3.04688 10.9588C3.04688 13.5578 5.16938 15.6647 7.78762 15.6647Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdBlowing);
export default __webpack_public_path__ + "static/media/coldBlowing.4f794c00.svg";
export { ForwardRef as ReactComponent };